import { ModalConfig, useModal } from 'components/modal/Modal'
import { ReactNode, useState } from 'react'

export interface PromisingModalProps<T> {
  close: () => void
  onResolve?: (value: T | null) => void
}

interface PromisingModalRenderProps<T> {
  (params: PromisingModalProps<T>): ReactNode
}

export function usePromisingModal<T>(
  render: PromisingModalRenderProps<T>,
  config?: ModalConfig & {
    isDisabled?: boolean
  }
) {
  const [resolver, setResolver] = useState<(value: T | null) => void>()

  const [modal, showModal, closeModal, isOpen] = useModal(
    ({ close, isOpen }) =>
      isOpen
        ? render({
            onResolve: resolver,
            close: close,
          })
        : null,
    {
      ...config,
      onClose: () => resolver?.(null),
    }
  )

  const showAndPromise = () => {
    if (config?.isDisabled) return null
    void showModal()
    return new Promise<T | null>((resolve) => setResolver(() => resolve))
  }

  return [modal, showAndPromise, closeModal, isOpen] as const
}
